// extracted by mini-css-extract-plugin
export var checkbox = "_8r-0";
export var circle = "_8r-3";
export var horizontalContainer = "_8r-7";
export var sm = "_8r-5";
export var switch0 = "_8r-2";
export var switchDisabled = "_8r-8";
export var switchEnabled = "_8r-1";
export var textSwitchContainer = "_8r-9";
export var textSwitchOption = "_8r-a";
export var textSwitchOptionSelected = "_8r-b";
export var verticalContainer = "_8r-6";
export var xs = "_8r-4";